import axios from "./axiosInstance";

// getTripBySlug: (slug) => axios.get("packagesdetails", slug),
const TripsDetailsAPI = {
  getTripBySlug: (payload) => axios.post(`packagesdetails`, payload),
};

export default TripsDetailsAPI;
